import styled from "styled-components"

export const StyledHiAboutMeSection = styled.section`
  width: 100%;
  position: relative;
`
